import React from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import './../styles/components/ToastCustom.less';

export const TOAST_TYPE_MAP = {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info'
};

export type ToastType = (typeof TOAST_TYPE_MAP)[keyof typeof TOAST_TYPE_MAP];

export const ToastCustom = (message: string, TOAST_TYPE: ToastType, requestId?: string, toastId?: string): any => {
    switch (TOAST_TYPE) {
        case 'success':
            return toast.success(
                <div className="toast-container">
                    <div className="icon-container">
                        <FontAwesomeIcon className="type-icon" id="green" icon="check-circle" size="2x" />
                    </div>
                    {message}
                </div>,
                { icon: false, ...(toastId && { toastId: toastId }) }
            );
        case 'error':
            return toast.error(
                <div className="toast-container">
                    <div className="icon-container">
                        <FontAwesomeIcon className="type-icon" id="red" icon="exclamation-triangle" size="2x" />
                    </div>
                    <div className="flex-column">
                        <div>{message}</div>
                        {requestId && <div className="sub-message">Request ID: {requestId}</div>}
                    </div>
                </div>,
                { icon: false, ...(toastId && { toastId: toastId }) }
            );
        case 'warning':
            return toast.warning(
                <div className="toast-container">
                    <div className="icon-container">
                        <FontAwesomeIcon className="type-icon" id="yellow" icon="exclamation-triangle" size="2x" />
                    </div>
                    {message}
                </div>,
                { icon: false, ...(toastId && { toastId: toastId }) }
            );
        default:
            return toast.info(
                <div className="toast-container">
                    <div className="icon-container">
                        <FontAwesomeIcon className="type-icon" id="blue" icon="info-circle" size="2x" />
                    </div>
                    {message}
                </div>,
                { icon: false, ...(toastId && { toastId: toastId }) }
            );
    }
};
